import { Env } from '@/types/Env';

const getEnv = (): Env => {
  return (window as any as { _env_: Env })?._env_ ?? {};
};

export default getEnv;
